import { ADMIN_ROLE, AVATAR_ADMIN_ROLE, CSR, SELLER_ROLE } from "../constants/common";
import { localStorageHelper } from "./storageHelper";
import { jwtDecode, JwtPayload } from "jwt-decode";

export interface CustomJwtPayloadEntitlement {
  entitlementName: string;
  read: number;
  write: number;
}

export interface CustomJwtPayload extends JwtPayload {
  sessionId: string;
  userId: number;
  tenantId: number;
  entitlements: CustomJwtPayloadEntitlement[];
  roles: string[];
  fullName: string;
  timezoneName: string;
}

export const getUserToken = () => {
  return localStorageHelper.get(CSR);
};

export const getSessionData = () => {
  const session = getUserToken();
  if (!session) {
    return null;
  }
  try {
    const decoded: CustomJwtPayload = jwtDecode(session.token);
    return decoded;
  } catch (error) {
    return null;
  }
};

export const getAllowedRoutes = () => {
  const data = getSessionData();
  if (!data) {
    return [];
  }
  return data.entitlements;
};

export const getTimezoneName = (): string => {
  const data = getSessionData();
  if (!data) {
    return "";
  }
  return data.timezoneName;
};

export const isAdminUser = () => {
  const data = getSessionData();
  if (!data) {
    return false;
  }
  return data.roles.includes(ADMIN_ROLE) || data.roles.includes(AVATAR_ADMIN_ROLE);
};

export const isSellerUser = () => {
  const data = getSessionData();
  if (!data) {
    return false;
  }
  return data.roles.includes(SELLER_ROLE);
};

export const getCurrentUser = () => {
  const data = getSessionData();
  if (!data) {
    return null;
  }
  return data;
};
